import { render } from "./svg-map.vue?vue&type=template&id=6c4b88b9&scoped=true&ts=true"
import script from "./svg-map.vue?vue&type=script&lang=ts"
export * from "./svg-map.vue?vue&type=script&lang=ts"

import "./svg-map.vue?vue&type=style&index=0&id=6c4b88b9&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4b88b9"]])

export default __exports__